import { isEmpty, wrap } from 'lodash';
import { useEffect, useState } from 'react';
import useObjectElements from '../../../hooks/useObjectElements';
import useUpdateStandardizationProject from '../hooks/useUpdateStandardizationProject';
import ProjectMouseoverView from '../../ProjectMouseoverView';
import { EditBtn, Column, Row } from '../styles';

import { useIdCatalogSearch } from '../../SideMenuSearchLane/context';

import {
  Wrapper,
  NameWrapper,
  Name,
  BigInput,
  NormalInput,
  InfoText,
  SaveBtn,
  CancelBtn,
  PhaseWrapper,
  PhaseText,
  BtnsWrapper,
  ProjectWrapper,
} from './styles';

const ProjectInfo = ({
  stProjectId,
  updateProject,
  name = '',
  clientName = '',
  fpsoType = 'FPSO type',
  phase = 0,
  phaseName = '',
  isAdmin,
  project,
  projectId,
}) => {
  const { isSideMenuCollapsed } = useIdCatalogSearch();
  const [isEditing, setIsEditing] = useState(false);
  const {
    object: formData,
    setObjectValue: setFormData,
    setMultipleObjectValues: setMultipleFormFields,
    resetObjectToInitValues: resetForm,
  } = useObjectElements({
    initialValues: {
      name,
      phaseName,
    },
  });

  const onSuccessfullyUpdated = () => {
    setIsEditing(false);
  };

  const onSave = () => {
    const updatedData = {
      id: stProjectId,
      name: formData.name,
      phaseName: formData.phaseName,
    };
    updateProject(stProjectId, updatedData, { onSuccess: onSuccessfullyUpdated });
  };

  const onCancel = () => {
    setIsEditing(false);
    resetForm();
  };

  useEffect(() => {
    setMultipleFormFields({
      name,
      phaseName,
    });
  }, [name, phaseName]);

  const wrapperStyles = isSideMenuCollapsed ? { marginLeft: '140px' } : { marginLeft: '300px' };

  return (
    <Wrapper style={wrapperStyles}>
      <Column>
        <Row
          alignItems='center'
          marginBottom='0.25rem'>
          <NameWrapper>
            {isEditing && isAdmin ? (
              <BigInput
                placeholder='Project Name'
                value={formData.name}
                onChange={(e) => setFormData('name', e.target.value)}
              />
            ) : (
              <Name>{name}</Name>
            )}
          </NameWrapper>
          <PhaseWrapper>
            {isEditing && isAdmin ? (
              <>
                <PhaseText>(Phase {phase}</PhaseText>
                <PhaseText style={{ margin: '0 5px' }}>-</PhaseText>
                <NormalInput
                  placeholder='Phase Description'
                  value={formData.phaseName}
                  onChange={(e) => e.target.value.length <= 40 && setFormData('phaseName', e.target.value)}
                />
                <PhaseText>)</PhaseText>
                <BtnsWrapper>
                  <SaveBtn onClick={onSave} />
                  <CancelBtn onClick={onCancel} />
                </BtnsWrapper>
              </>
            ) : (
              <>
                <PhaseText>({`Phase ${phase} ${phaseName ? `- ${phaseName}` : ''}`})</PhaseText>
                {isAdmin && (
                  <BtnsWrapper>
                    <EditBtn onClick={() => setIsEditing(true)} />
                  </BtnsWrapper>
                )}
              </>
            )}
          </PhaseWrapper>
        </Row>
        <InfoText
          alignItems='center'
          marginBottom='0.25rem'>
          <ProjectWrapper>{project}</ProjectWrapper>
        </InfoText>
        {/*<ProjectMouseoverView projectId={projectId}/>*/}
        <InfoText>{clientName}</InfoText>
        {/* <InfoText>{fpsoType}</InfoText> */}
      </Column>
    </Wrapper>
  );
};

export default ProjectInfo;
